import { client } from '@/services/api/axios.ts';
import { useQuery } from '@tanstack/react-query';
import { NotificationRule } from '@/features/notification-rules/schemas/notification-rules.schema.ts';

export const useGetUserNotificationRulesQuery = () => {
  return useQuery({
    queryKey: ['notifications', 'rules'],
    queryFn: async () => {
      const { data } = await client.get<{ body: NotificationRule[] }>(`/notifications/rules`);

      return data.body;
    },
    refetchInterval: 1000 * 60 * 5,
  });
};
